module.exports = __webpack_public_path__ + "img/img-15.49ae0d50.png";